export const ProjectStatus = {
  ACTIVE: 1,
  ACTIVE_CONCLUDE_CONTRACT: 2,
  WAITING_POTENTIAL_TEAM_TO_RESPOND: 3,
  WAITING_CHOOSE_PROJECT_MANAGER: 4,
  COMPLETED: 5,
  STOPPED: 7,
  WAITING_PICK_UP_TASKS_CREATE_TEAM: 8,
  WAITING_CONFIRM_PROJECT_TASKS: 9,
  contains: function (statusId, statuses) {
    if (statuses.includes(statusId)) {
      return true;
    }
    return false;
  },
  isTeamLeadNotChosenStatuses(statusId) {
    return this.contains(statusId, [
        this.WAITING_POTENTIAL_TEAM_TO_RESPOND,
        this.WAITING_CHOOSE_PROJECT_MANAGER
    ]);
  },
  isCanDoChangesStatuses(statusId) {
    return this.contains(statusId, [
      this.ACTIVE,
      this.ACTIVE_CONCLUDE_CONTRACT,
      this.WAITING_POTENTIAL_TEAM_TO_RESPOND,
      this.WAITING_CHOOSE_PROJECT_MANAGER,
      this.WAITING_PICK_UP_TASKS_CREATE_TEAM
    ]);
  },
  isTasksFixedStatuses(statusId) {
    return this.contains(statusId, [
      this.ACTIVE_CONCLUDE_CONTRACT,
      this.ACTIVE,
      this.COMPLETED,
      this.STOPPED
    ]);
  },
  isProjectManagerViableStopStatuses(statusId) {
    return this.contains(statusId, [
      this.ACTIVE_CONCLUDE_CONTRACT,
      this.WAITING_POTENTIAL_TEAM_TO_RESPOND,
      this.WAITING_CHOOSE_PROJECT_MANAGER,
      this.WAITING_PICK_UP_TASKS_CREATE_TEAM
    ]);
  },
  isInviteSpecialistStatuses(statusId) {
    return this.contains(statusId, [
      this.WAITING_POTENTIAL_TEAM_TO_RESPOND,
      this.WAITING_CHOOSE_PROJECT_MANAGER,
      this.WAITING_PICK_UP_TASKS_CREATE_TEAM
    ]);
  },
  isWaiting(statusId) {
    return this.contains(statusId, [
      this.WAITING_POTENTIAL_TEAM_TO_RESPOND,
      this.WAITING_CHOOSE_PROJECT_MANAGER,
      this.WAITING_PICK_UP_TASKS_CREATE_TEAM,
      this.WAITING_CONFIRM_PROJECT_TASKS
    ]);
  }
}